import type { StepsTabs } from '@/scopes/checkout/domain/types/stepTabs'
import { Icon } from '@sunwebgroup/uds-ui/icon'
import * as React from 'react'
import { useIntl } from 'react-intl'
import { buildUrlWithCurrentParams } from '@/scopes/checkout/domain/helpers/BuildUrlWithCurrentParams'
import { useBookingDraftQuery, useGetStepsTabs } from '@/scopes/checkout/domain/hooks'
import { TopNavigationBarItem } from '@/scopes/common/components/Header'
import styles from './CheckoutPreviousStepHeader.module.css'

function getPreviousCompletedStep(items: NonNullable<StepsTabs['steps']['items']>) {
  for (let index = items.length - 1; index >= 0; index--) {
    const step = items[index]

    if (step.completed)
      return step
  }

  return undefined
}

export function CheckoutPreviousStepHeader() {
  const { isLoading: isDraftLoading, data } = useBookingDraftQuery()
  const { isLoading: isTabsLoading, items } = useGetStepsTabs()
  const intl = useIntl()

  const isLoading = isDraftLoading || isTabsLoading

  if (isLoading)
    return <div className={styles.wrapper} translate="no" />

  const previousStepFromTabs = getPreviousCompletedStep(items)
  const bookingDraftPreviousStep = data?.navigation?.previousStep

  if (!previousStepFromTabs && !bookingDraftPreviousStep)
    return <div className={styles.wrapper} translate="no" />

  if (data?.error && data.error.hasError)
    return <div className={styles.wrapper} translate="no" />

  const url = previousStepFromTabs
    ? buildUrlWithCurrentParams(previousStepFromTabs.url)
    : bookingDraftPreviousStep!.url

  const text = previousStepFromTabs
    ? previousStepFromTabs.text
    : intl.formatMessage({ id: 'checkout_steps_header_previous_step_your_trip', defaultMessage: 'Your trip' })

  return <CheckoutPreviousStepButton url={url} text={text} />
}

export function CheckoutPreviousStepButton({ url, text }: { url: string, text: string }) {
  return (
    <div className={styles.wrapper} translate="no">
      <TopNavigationBarItem
        className={styles.backButton}
        as="a"
        href={`${url}`}
        data-qa="checkout-previous-step-button"
      >
        <Icon glyph="ChevronLeft" />
        {text}
      </TopNavigationBarItem>
    </div>
  )
}
